"use client";

import { Locale } from "@/i18n/config";
import { setUserLocale } from "@/lib/locale";
import { LanguageSwitcher } from "@workspace/ui/components/language-switcher";

export function ClientLanguageSwitcher() {
  return (
    <LanguageSwitcher
      locales={{
        en: "English",
        el: "Ελληνικά",
        es: "Español",
      }}
      onChangeLanguage={(lang) => {
        setUserLocale(lang as Locale).then(() => {});
      }}
    />
  );
}
